import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "../rich-text-editor.module.scss";
import { useEditorDisabled } from "../use-editor-disabled";

/**
 * Base control wrapper — used as the trigger for custom toolbar controls (e.g. menu-based dropdowns) so they pick up
 * the same toolbar-button styling as the built-in Bold/Italic/etc. controls. Uses forwardRef so consumers like
 * Mantine's `<Menu.Target>` can attach their cloneElement-injected ref to the underlying button (without it the
 * dropdown can't anchor and renders at viewport 0,0).
 *
 * `disabled` is auto-derived from the surrounding editor's `isEditable` state. Pass an explicit `disabled` to override.
 */
export const Control = forwardRef<HTMLButtonElement, RichTextEditorControlProps>(
    ({ className, disabled, ...other }, ref) => {
        const effectiveDisabled = useEditorDisabled(disabled);
        return (
            <MantineRichTextEditor.Control
                ref={ref}
                className={clsx(styles["control"], className)}
                disabled={effectiveDisabled}
                {...other}
            />
        );
    }
);

Control.displayName = "RichTextEditor.Control";
